import React, {createContext, useContext} from 'react';

export const ServiceUrlsOverrideContext = createContext({ customLoyaltyEngineUrl: '' });

export const ServiceUrlsOverrideProvider = ({ customLoyaltyEngineUrl = '', children }) => {
    return (
        <ServiceUrlsOverrideContext.Provider value={{ customLoyaltyEngineUrl }}>
            {children}
        </ServiceUrlsOverrideContext.Provider>
    );
};

export const useCustomLoyaltyEngineUrl = () => {
    const { customLoyaltyEngineUrl } = useContext(ServiceUrlsOverrideContext);
    return customLoyaltyEngineUrl;
};

